import { useState } from "react"

const TextInput = ({entity, fld, indentAttr=null}) => {
    const [error, setError] = useState(null)
    // console.log(fld)
    const defaultChangeHandler = (event) => {
        // console.log(entity.id)
        setError(null)
        const newVal = event.target.value
        if(!!fld.changeHandler) {
            fld.changeHandler(entity.id, fld.name, newVal)
        } else {
            console.log("defaultChangeHandler", fld.name, newVal)
        }
    }
    const defaultBlur = (event) => {
        if (!!fld.unique && !!fld.uniqueValues && !!fld.records) {
            const {value} = event.target
            if (!fld.uniqueValues.includes(value)) {
                return
            }
            // if it isn't unique, it's OK if the value
            // is associated THIS entities fld
            const potentialDups = fld.records
                .filter(e => e[fld.name] === value)
                .filter(e => e.id !== entity.id)
            if (potentialDups.length > 0) {
                setError("value is not unique")
            }
        }
    }

    return (
        <>
        <input
            type="text"
            name={fld.name}
            size={!!fld.size ? fld.size : 40}
            value={entity[fld.name]}
            onChange={defaultChangeHandler}
            onBlur={defaultBlur}
            style={{
                marginLeft: !indentAttr ? "0" : `${entity[indentAttr] * 20}px`
            }}
        />
        {!!error && (
        <>
            <br/>
            <span className="error-message">
                {error}
            </span>
        </>)
        }
        </>
    )
}

export default TextInput